<template>
  <div>
    <section class="section section-shaped section-lg my-0">
      <div class="container pt-lg-md">
        <div class="row">
          <div class="col-sm-12">
            <div class="card"  v-if="loading">
              <div class="card-body">
                <div class="text-center">
                  <img style="max-height: 70px;" v-bind:src="'./img/custom/loading.svg'">Loading...
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-4 col-lg-3" style="margin-bottom: 20px" v-for="ally of allies" v-bind:key="ally.id">
            <div class="card">
              <img v-bind:src="ally.logo" class="card-img-top">
              <div class="card-body">
                <h5 class="card-title align-middle" style="min-height: 54px">{{ally.name}}</h5>
                <router-link v-bind:to="'/beneficio/'+ally.slug">
                <base-button type="primary">Ver beneficio</base-button>
                </router-link>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { isArray } from "util";

const axios = require("axios");

export default {
  data() {
    return {
      loading: false,
      ally: {
        id: "",
        name: "",
        logo: "",
        slug: "",
      },
      allies: []
    };
  },
  methods: {
    async getAllies() {
      this.loading = true;

      try {
        var response = await axios.get(
          "https://hgogjz2lrh.execute-api.us-west-2.amazonaws.com/api/allies"
        );

        if (isArray(response.data)) {
          this.allies = response.data;
        } else if (response.data == "there_are_no_registered_allies") {
          alert("No hay aliados registrados para mostrar");
        } else {
          alert("Ocurrió un error consultando la lista de aliados");
        }
        this.loading = false;
      } catch (err) {
        console.error(error);
        alert("Ocurrió un error consultando la lista de aliados");
        this.loading = false;
      }
    }
  },
  mounted: function() {
    this.getAllies();
  }
};
</script>
<style>
</style>
